import axios from "axios"
import { getUser, getCurrentBranch } from "helpers/auth-helper"
import { json } from "react-router-dom"

export const getByUser = async ({ params }) => {
    const user = getUser()
    const currentBranch = getCurrentBranch()
    var is_super = false

    if (user.roles.length === 0) {
        is_super = false
    } else {
        if (currentBranch) {
            is_super =  currentBranch?.roles?.find((role) => role.is_super === 1) ? true : false
        } else {
            is_super =  user?.roles?.find((role) => role.is_super === 1) ? true : false
        }
    }

    if (is_super) {
        return axios.get(`${process.env.REACT_APP_GENERIC_API_URL}/branch?paginate=false`, {
            params: {}
        }).then(res => res.data.data).catch((error) => {
            throw new json(error, error.response.status)
        })
    } else {
        return axios.get(`${process.env.REACT_APP_GENERIC_API_URL}/branch/by`, {
            params: {
                user_id: user.id
            }
        }).then(res => res.data.data).catch((error) => {
            throw new json(error, error.response.status)
        })
    }
}